module.exports = __webpack_public_path__ + "img/25_33.a7ae7dcf.png";